import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, MessageCircle, Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { copyText, fmtDateTime, waPhone } from "@/lib/format";

export const SignRequestDialog = ({ doc, onOpenChange, onDone, reactivate = false }) => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setInfo(null);
    if (doc) { api.post(`/docs/files/${doc.id}/sign-request`, { email: false, reactivate }).then((r) => setInfo(r.data)).catch((e) => { toast.error(apiError(e).message); onOpenChange(false); }); }
  }, [doc]); // eslint-disable-line react-hooks/exhaustive-deps
  const en = doc?.lang === "en";
  const text = info && (en ? `Hello ${info.guest_name || ""}, please sign your document here (valid 48 h): ${info.url}` : `Hola ${info.guest_name || ""}, por favor firma tu documento aquí (válido 48 h): ${info.url}`);
  const copy = async () => { if (await copyText(info.url)) toast.success("Enlace copiado"); };
  const email = async () => {
    setBusy(true);
    try { await api.post(`/docs/files/${doc.id}/sign-request`, { email: true }); toast.success(`Enlace para firmar enviado a ${info.email}`); onDone?.(); }
    catch (e) { toast.error(apiError(e).message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!doc} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="sign-request-dialog">
        <DialogHeader>
          <DialogTitle>{reactivate ? "Enlace de firma reactivado" : "Pedir firma del huésped"}</DialogTitle>
          <DialogDescription>El huésped abre el enlace en su celular, revisa el documento, sube la foto de su identificación y firma con el dedo. Al terminar, el enlace se cancela y el PDF firmado se guarda en el historial.</DialogDescription>
        </DialogHeader>
        {!info ? <div className="h-24 animate-pulse rounded-lg bg-slate-100" /> : (
          <div className="space-y-4">
            <p className="break-all rounded-lg bg-slate-50 p-3 font-mono text-xs text-slate-700" data-testid="sign-request-url">{info.url}</p>
            <p className="text-xs text-slate-500" data-testid="sign-request-expires">Válido hasta {fmtDateTime(info.expires_at)}</p>
            <div className="grid gap-2 sm:grid-cols-3">
              <Button variant="outline" onClick={copy} data-testid="sign-request-copy-btn"><Copy size={15} className="mr-1.5" />Copiar</Button>
              <Button asChild variant="outline" className="text-emerald-700" data-testid="sign-request-whatsapp-btn">
                <a href={`https://wa.me/${waPhone(info.phone)}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer"><MessageCircle size={15} className="mr-1.5" />WhatsApp</a>
              </Button>
              <Button variant="outline" onClick={email} disabled={busy || !info.email} title={info.email || "El cobro no tiene correo"} data-testid="sign-request-email-btn"><Mail size={15} className="mr-1.5" />{busy ? "Enviando…" : "Correo"}</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
